import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to MLB.com",
    description:
      "Click Continue and connect your St. Paul Saints account using our secure MLB.com login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your{" "}
        <Link
          target="_blank"
          href="https://sp6.glitnirticketing.com/spticket/web/login.php?ret_link=%2Fspticket%2Fweb%2Fwportal.php&type=notLogged"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
        >
          MyProVenue
        </Link>{" "}
        within 24 hours of purchase. Reach out to Live Fan Support for any
        questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does this offer work?",
    description:
      "For our Securian Financial Club, you can purchase 1 game at $140, 2-5 games at $130 per ticket per game, 6-8 games at $120 per ticket per game. If you purchase 9 or more games in our Securian Financial Club, you can purchase those tickets at $100 per ticket per game along with receiving a separate link to have the opportunity to purchase Banana Ball tickets to one of the two available dates in August 2025.",
  },
  {
    title: "Do I have to select all my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all current available inventory.",
  },
  {
    title: "Where are event tickets delivered?",
    description: (
      <>
        Tickets are delivered directly within your{" "}
        <Link
          target="_blank"
          href="https://sp6.glitnirticketing.com/spticket/web/login.php?ret_link=%2Fspticket%2Fweb%2Fwportal.php&type=notLogged"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
        >
          St. Paul Saints MyProVenue Account
        </Link>
        . A separate URL will be sent to your email if you purchase 9 or more
        games through this offer
      </>
    ),
  },
];
